'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const components_navigation_InteractiveTag_InteractiveTag = require('./InteractiveTag.cjs.js');
const components_navigation_InteractiveTag_InteractiveTagIcon = require('./InteractiveTagIcon.cjs.js');
const components_navigation_InteractiveTag_InteractiveTagContent = require('./InteractiveTagContent.cjs.js');
const components_navigation_InteractiveTag_InteractiveTagWrapper = require('./InteractiveTagWrapper.cjs.js');
const components_navigation_InteractiveTag_InteractiveTags = require('./InteractiveTags.cjs.js');

const InteractiveTag = Object.assign(components_navigation_InteractiveTag_InteractiveTag.InteractiveTag, {
  /** @deprecated Use ActionChip or FilterChipList instead */
  Icon: components_navigation_InteractiveTag_InteractiveTagIcon.InteractiveTagIcon,
  /** @deprecated Use ActionChip or FilterChipList instead */
  Content: components_navigation_InteractiveTag_InteractiveTagContent.InteractiveTagContent,
  /** @deprecated Use ActionChip or FilterChipList instead */
  Wrapper: components_navigation_InteractiveTag_InteractiveTagWrapper.InteractiveTagWrapper
});

exports.InteractiveTags = components_navigation_InteractiveTag_InteractiveTags.InteractiveTags;
exports.InteractiveTag = InteractiveTag;
//# sourceMappingURL=index.cjs.js.map
